import React from "react";
import { ATTRACTIONS } from "../../data/site";
import { MapPin, Car } from "lucide-react";

export default function Location() {
  return (
    <section id="location" data-testid="location-section" className="relative py-20 sm:py-28 px-4 sm:px-6 lg:px-10">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-[1fr_1.1fr] gap-12 items-start">
        <div>
          <span className="inline-block bg-brand-blue text-white font-fredoka font-bold rounded-full px-4 py-1.5 border-4 border-slate-900 neo-shadow-sm rotate-[-2deg]">
            LOCATION
          </span>
          <h2 className="font-fredoka font-bold text-4xl sm:text-5xl lg:text-6xl mt-6 text-slate-900">
            In the heart of <span className="text-brand-red">Frisco.</span>
          </h2>
          <p className="mt-4 text-lg text-slate-700 leading-relaxed">
            Tucked into a cozy, quiet neighborhood — yet minutes from Universal Kids Resort, downtown Dallas, top-rated restaurants and Frisco&apos;s best family attractions.
          </p>

          <div className="mt-8 bg-brand-yellow border-4 border-slate-900 rounded-3xl p-6 neo-shadow">
            <div className="flex items-start gap-3">
              <MapPin className="flex-shrink-0 mt-1" />
              <div>
                <p className="font-fredoka font-bold text-xl text-slate-900">UniversalHouse TX</p>
                <p className="font-quicksand text-slate-800">Frisco, Texas</p>
                <p className="font-quicksand text-slate-800 mt-1 text-sm">Exact address shared after booking confirmation</p>
              </div>
            </div>
          </div>
        </div>

        <div data-testid="attractions-grid" className="grid sm:grid-cols-2 gap-4">
          {ATTRACTIONS.map((a, i) => (
            <div
              key={a.name}
              data-testid={`attraction-${i}`}
              className="bg-white border-4 border-slate-900 rounded-3xl p-5 neo-shadow-sm flex gap-4 items-start"
            >
              <div className="flex-shrink-0 w-16 h-16 grid place-items-center rounded-2xl bg-brand-red text-white border-4 border-slate-900 neo-shadow-sm">
                <div className="text-center font-fredoka font-bold leading-none">
                  <div className="text-base">{a.time.split(" ")[0]}</div>
                  <div className="text-[10px] uppercase tracking-wide mt-0.5">{a.time.split(" ")[1]}</div>
                </div>
              </div>
              <div>
                <div className="flex items-center gap-2">
                  <Car size={14} className="text-slate-500" />
                  <span className="text-xs font-quicksand font-semibold text-slate-500 uppercase">By car</span>
                </div>
                <p className="font-fredoka font-bold text-lg text-slate-900 leading-tight mt-1">{a.name}</p>
                <p className="font-quicksand text-sm text-slate-600 mt-1">{a.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
